import { Directive, ComponentFactoryResolver, ComponentFactory, ComponentRef } from '@angular/core';

import { ShellService } from '~core/services';
import { PropertyDetailPopupComponent } from './property-detail-popup.component';
import { ModalService } from '~/shared/services';

@Directive({
  selector: '[propertyDetailPopupAnchor]'
})

export class PropertyDetailPopupAnchorDirective {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private modalService: ModalService,
    private shellService: ShellService
  ) { }

  public createPropertyDetailPopup(popupComponent: { new(...args: any[]): PropertyDetailPopupComponent }, property: any): ComponentRef<PropertyDetailPopupComponent> {
    const vcr = this.shellService.getRootElement();
    let popupComponentFactory = this.componentFactoryResolver.resolveComponentFactory(popupComponent);
    let popupComponentRef = vcr.createComponent(popupComponentFactory);

    if (this.modalService.isModalDefined()) {
      this.modalService.closeModal();
    }

    this.modalService.setModal(popupComponentRef);

    popupComponentRef.instance.property = property;
    popupComponentRef.changeDetectorRef.reattach();

    popupComponentRef.instance.subscriptions.push(popupComponentRef.instance.close.subscribe(() => {
      popupComponentRef.destroy();
    }));

    return popupComponentRef;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/property/components/popup/property-detail-popup-anchor.directive.ts